import { main } from './output/Foliage.App.Main/index.js'; main();
